import React from 'react';
import { Row, Col, Input, Card, Button, Media } from 'reactstrap';
import { useMicroReception } from '../../../hooks/microsanitaryReception/useMicroReception';
import { ModalSampleMicro } from './ModalSampleMicro';
import { SamplesTable } from './SamplesTable';
import { ConfigServer } from '../../../data/config';




export const IndexSampleReception = () => {
    const {
        checkNim,
        handleInputChangeNim,
        formNim,
        showDetails,
        samples,
        handleCloseViewSend,
        gender,
        age, namepatien, datanim, curp, phone, maternal_surname, paternal_surname, code,
        isModalOpen,
        selectedSample,
        handleOpenModal,
        handleCloseModal,
        thermometers,
        containers,
        handleChangeMic,
        saveMicDetailSend,
        reasons,
        status,
        units,
        nameBranch,
        _nim,
        navigateQuoter,
        characteristic,
        handleOpenModalAuthorization,
        handleCloseModalAuthorization,
        isModalAuthorization,
        password,
        setPassword,
        saveValidate,
        invalidPasword,
        messageInvalid,
     

    } = useMicroReception();

    const { nim } = formNim;

    return (
        <Col sm="12" >
            <Card>
                <div style={{
                    backgroundColor: "#4694c0",
                    borderRadius: "8px 8px 0 0",
                    padding: "15px",
                    color: "#fff",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
                }}>
                    <Col sm="12">
                        <Row>
                            <Col>
                                <div style={{
                                    fontSize: "1.25em",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}>
                                    Recepción de Muestras
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </div>
            </Card>

            <Card className='shadow'>

                <Col style={{ textAlign: "center" }} className='p-r-0 p-l-0'>
                    {!showDetails ? (
                        <div className={_nim === undefined ? "" : "d-none"}  style={{ textAlign: "-webkit-center" }}>
                            <br />
                            <br />

                           
                            <div className='a-line'>
                                <label className='labelIniciarMuestra'>
                                    Escanea el <b>Código de barras</b> de las muestras
                                </label> <br />
                                <label className='labelCode'>o</label> <br />
                                <Col sm="9">
                                    <Input
                                        className="tamañoinputID text-center form-control form-control-sm input-air-primary"
                                        placeholder="Ingrésalo manualmente"
                                        name="nim"
                                        value={nim}
                                        onChange={handleInputChangeNim}
                                    />
                                </Col>
                                <br />
                                <button
                                    className="modalButton"
                                    onClick={checkNim}
                                    style={{ backgroundColor: "#1f4e69" }}
                                >
                                    Ingresar
                                </button>
                                <br /><br /><br />
                            </div>
                        </div>
                    ) : (
                        <Col>
                            <Col sm="12" className='p-r-0' style={{ textAlign: "end" }} >
                                <br />
                                <Button outline color='danger' size='sm' onClick={() => _nim === undefined ?  handleCloseViewSend() : navigateQuoter() }>
                                    {
                                        _nim === undefined ? "Regresar" : "Regresar a cotización"
                                    }
                                </Button>
                            </Col>
                            <Col sm="12" >
                            <Row>
                                <Col sm="2" className='p-l-0'>
                                    <div className="media profile-media">
                                        <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "80%" }} alt="Logo" />
                                    </div>
                                </Col>
                                <Col sm="3" className='pt-3' style={{ textAlign: "center" }}>
                                <label className='f-w-600' >Cliente</label>  <br />
                                <label className='f-w-600' style={{ fontSize: "12px", color: "#6c757dc9" }}>{namepatien} </label>                            
                                </Col>
                                <Col sm="3" className='pt-3' style={{ textAlign: "-webkit-center" }}>
                                <label className='f-w-600' >Código de de la cotización</label>  <br />
                                <div style={{
										backgroundColor: "#f97316",
										width: "110px",
										height: "20px",
										borderRadius: "8px",
										color: "#fff",
										fontSize:"10px",
										paddingTop:"1px"
									    }}>
                                    <i className="fa fa-angle-right f-12"></i>&nbsp;
                                    <label className='f-w-600' style={{fontSize:"10px"}} >{code ?? "------"}</label>
								</div> 
                                </Col>
                                <Col sm="3" className='pt-3' style={{ textAlign: "center" }}>
                                <label className='f-w-600' >Nim</label>  <br />
                                <label className='f-w-600' style={{ fontSize: "12px", color: "#6c757dc9" }}>{datanim} </label>                            
                                </Col>
                            </Row>
                            </Col>
                            <br /><br />

                            <SamplesTable samples={samples} onEditSample={handleOpenModal}  handleOpenModalAuthorization={handleOpenModalAuthorization}
                                handleCloseModalAuthorization={handleCloseModalAuthorization}
                                isModalAuthorization={isModalAuthorization} selected={selectedSample} password={password}
        setPassword={setPassword}  saveValidate={saveValidate} invalidPasword={invalidPasword} messageInvalid={messageInvalid} />
                            <ModalSampleMicro
                                isOpen={isModalOpen}
                                toggle={handleCloseModal}
                                sample={selectedSample}
                                samples={samples}
                                thermometers={thermometers}
                                containers={containers}
                                reasons={reasons}
                                status={status}
                                handleChangeMic={handleChangeMic}
                                saveMicDetailSend={saveMicDetailSend}
                                units={units}
                                characteristic={characteristic}
                            />

                        </Col>
                    )}
                </Col>
            </Card >
        </Col >

    );
};